import { createAsyncThunk } from '@reduxjs/toolkit'
import { careerLandingManagementAPI } from 'src/api/career-landing-management'
import { IApplicationProcessSchema } from 'src/components/career-landing-page-management/applicationProcess/applicationProcessSchema'
import { IBannerTop } from 'src/components/career-landing-page-management/banner/bannerSchema'
import { IJobSchema } from 'src/components/career-landing-page-management/exploreOurOpportunity/schema'
import { ISeoPageSchema } from 'src/components/career-landing-page-management/seoConfig/seoConfigSchema'
import { IWhyJoinUsSchema } from 'src/components/career-landing-page-management/whyJoinUs/whyJoinUsSchema'
import {
  ECareerBannerType,
  IJobQuery,
} from 'src/interfaces/career-landing-management'

// Banner Actions
export const createCareerBannerTopAction = createAsyncThunk(
  'career-landing-management/banner-top/create',
  async (params: IBannerTop) => {
    try {
      const res = await careerLandingManagementAPI.createBanner(params)
      return res
    } catch (error) {
      throw error
    }
  }
)

export const getCareerBannerTopAction = createAsyncThunk(
  'career-landing-management/banner-top/get',
  async (type: ECareerBannerType) => {
    try {
      const res = await careerLandingManagementAPI.getBanner(type)
      return res
    } catch (error) {
      throw error
    }
  }
)

// bottom
export const createCareerBannerBottomAction = createAsyncThunk(
  'career-landing-management/banner-bottom/create',
  async (params: IBannerTop) => {
    try {
      const res = await careerLandingManagementAPI.createBanner(params)
      return res
    } catch (error) {
      throw error
    }
  }
)

export const getCareerBannerBottomAction = createAsyncThunk(
  'career-landing-management/banner-bottom/get',
  async (type: ECareerBannerType) => {
    try {
      const res = await careerLandingManagementAPI.getBanner(type)
      return res
    } catch (error) {
      throw error
    }
  }
)

// About LLC
export const createCareerAboutLlcAction = createAsyncThunk(
  'career-landing-management/about-llc/create',
  async (params: IBannerTop) => {
    try {
      const res = await careerLandingManagementAPI.createBanner(params)
      return res
    } catch (error) {
      throw error
    }
  }
)

export const getCareerAboutLlcAction = createAsyncThunk(
  'career-landing-management/about-llc/get',
  async (type: ECareerBannerType) => {
    try {
      const res = await careerLandingManagementAPI.getBanner(type)
      return res
    } catch (error) {
      throw error
    }
  }
)

// why join us
export const getCareerWhyJoinUsAction = createAsyncThunk(
  'career-landing-management/why-join-us/get',
  async () => {
    try {
      const res = await careerLandingManagementAPI.getWhyJoinUsList()
      return res
    } catch (error) {
      throw error
    }
  }
)
export const createCareerWhyJoinUsAction = createAsyncThunk(
  'career-landing-management/why-join-us/post',
  async (body: IWhyJoinUsSchema) => {
    try {
      const res = await careerLandingManagementAPI.createWhyJoinUs(body)
      return res
    } catch (error) {
      throw error
    }
  }
)

export const updateCareerWhyJoinUsAction = createAsyncThunk(
  'career-landing-management/why-join-us/put',
  async ({ body, id }: { body: Partial<IWhyJoinUsSchema>; id: string }) => {
    try {
      const res = await careerLandingManagementAPI.updateWhyJoinUsById(body, id)
      return res
    } catch (error) {
      throw error
    }
  }
)
export const deleteCareerWhyJoinUsAction = createAsyncThunk(
  'career-landing-management/why-join-us/delete',
  async (id: string) => {
    try {
      const res = await careerLandingManagementAPI.deleteWhyJoinUs(id)
      return res
    } catch (error) {
      throw error
    }
  }
)

// application process
export const getCareerApplicationProcessAction = createAsyncThunk(
  'career-landing-management/application-process/get',
  async () => {
    try {
      const res = await careerLandingManagementAPI.getApplicationProcessList()
      return res
    } catch (error) {
      throw error
    }
  }
)
export const createCareerApplicationProcessAction = createAsyncThunk(
  'career-landing-management/application-process/post',
  async (body: IApplicationProcessSchema) => {
    try {
      const res = await careerLandingManagementAPI.createApplicationProcess(
        body
      )
      return res
    } catch (error) {
      throw error
    }
  }
)

export const updateCareerApplicationProcessAction = createAsyncThunk(
  'career-landing-management/application-process/put',
  async ({
    body,
    id,
  }: {
    body: Partial<IApplicationProcessSchema>
    id: string
  }) => {
    try {
      const res = await careerLandingManagementAPI.updateApplicationProcessById(
        body,
        id
      )
      return res
    } catch (error) {
      throw error
    }
  }
)
export const deleteCareerApplicationProcessAction = createAsyncThunk(
  'career-landing-management/application-process/delete',
  async (id: string) => {
    try {
      const res = await careerLandingManagementAPI.deleteApplicationProcess(id)
      return res
    } catch (error) {
      throw error
    }
  }
)

//seo
export const getCareerPageSeoAction = createAsyncThunk(
  'career-landing-management/seo/get',
  async () => {
    try {
      const res = await careerLandingManagementAPI.getPageSeo()
      return res
    } catch (error) {
      throw error
    }
  }
)
export const updateCareerPageSeoAction = createAsyncThunk(
  'career-landing-management/seo/update',
  async (body: ISeoPageSchema) => {
    try {
      const res = await careerLandingManagementAPI.updatePageSeo(body)
      return res
    } catch (error) {
      throw error
    }
  }
)
// explore opportunity
export const getJobAction = createAsyncThunk(
  'career-landing-management/job/get',
  async (query: IJobQuery) => {
    try {
      const res = await careerLandingManagementAPI.getJobList(query)
      return res
    } catch (error) {
      throw error
    }
  }
)
export const createJobAction = createAsyncThunk(
  'career-landing-management/job/create',
  async (body: IJobSchema) => {
    try {
      const res = await careerLandingManagementAPI.createJobPosting(body)
      return res
    } catch (error) {
      throw error
    }
  }
)

export const deleteJobAction = createAsyncThunk(
  'career-landing-management/job/delete',
  async (id: string) => {
    try {
      const res = await careerLandingManagementAPI.deleteJobPosting(id)
      return res
    } catch (error) {
      throw error
    }
  }
)
